import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class StorageHas extends BuiltinInstanceMemberCall {
    constructor(type) {
        super();
        this.type = type;
    }
    canCall(_sb, _func, node) {
        return tsUtils.argumented.getArguments(node).length === 1;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        if (tsUtils.argumented.getArguments(node).length < 1) {
            return;
        }
        const arg = tsUtils.argumented.getArguments(node)[0];
        const type = sb.context.analysis.getType(arg);
        sb.visit(arg, options);
        sb.emitHelper(node, optionsIn, sb.helpers.hasStructuredStorage({ type: this.type, keyType: type }));
    }
}

//# sourceMappingURL=has.js.map
